import React from 'react';

const Membership = () => {
  return (
    <div className="min-h-screen pt-24 bg-gray-50">
      <div className="container-custom">
        <h1 className="text-3xl font-bold text-gray-900">Membership</h1>
        <p className="text-gray-600 mt-2">Membership details coming soon</p>
      </div>
    </div>
  );
};

export default Membership;